import { render, staticRenderFns } from "./CheckoutProductItems.vue?vue&type=template&id=1b193bfb&scoped=true"
import script from "./CheckoutProductItems.vue?vue&type=script&lang=js"
export * from "./CheckoutProductItems.vue?vue&type=script&lang=js"
import style0 from "./CheckoutProductItems.vue?vue&type=style&index=0&id=1b193bfb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b193bfb",
  null
  
)

export default component.exports